/**
 * This file is generated from scripts/genIconComponents.js. Any
 * changes should be made in that file.
 */
import React, { forwardRef, Ref } from "react";
import { getSvgResourceForSize, getDefaultSize } from "../../utils";
import { Icon, LodestarIconProps } from "../../icon";
import { SvgColoredDatePicker as ColoredDatePickerMedium } from "./medium/ColoredDatePicker";
const sizeMap = {
    medium: ColoredDatePickerMedium,
};
const defaultSize = getDefaultSize(sizeMap);

export const ColoredDatePickerIcon = forwardRef(
    (
        { size = defaultSize, ...rest }: LodestarIconProps,
        ref: Ref<HTMLElement>
    ) => (
        <Icon
            ref={ref}
            svgComponent={getSvgResourceForSize(sizeMap, size)}
            size={size}
            {...rest}
        />
    )
);
ColoredDatePickerIcon.displayName = "ColoredDatePickerIcon";
